import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["output", "whyRating"]

  connect() {
    // console.log('range connected');
    // this.outputTarget.textContent = this.element.querySelector('input[type="range"]').value;
  }

  update() {
    const percentRating = event.target.value;

    this.outputTarget.textContent = "Feeling: " + percentRating + "%";

    if (percentRating < 100) {
      this.whyRatingTarget.setAttribute("required", true);
    } else {
      this.whyRatingTarget.removeAttribute("required");
    }

  }
}
